import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchRecentConversations'

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Recent conversations',
  },
  listAriaLabel: {
    id: `${scope}.listAriaLabel`,
    defaultMessage: 'Recent conversations',
  },
  draftStatus: {
    id: `${scope}.draftStatus`,
    defaultMessage: 'Draft',
  },
})
